/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationsettings1Inputs */

const vi_notificationsettings1 = /** @type {(inputs: Notificationsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt thông báo`)
};

/**

* @param {Notificationsettings1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const notificationsettings1 = /** @type {((inputs?: Notificationsettings1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationsettings1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notificationsettings1(inputs)
});
export { notificationsettings1 as "notificationSettings" }